<template>
    <div
        class="layout"
        :class="`
            ${
                authUser
                    ? `layout--auth layout--authrole--${authUser?.current_profile?.system_role?.id}`
                    : 'layout--guest'
            }
            ${currentDepartment?.type === DepartmentType.Employ ? `layout--auth layout--employ` : 'layout--guest'}
            ${showFullLayout() ? '' : 'layout--login'}
            ${backgroundClass}
        `"
    >
        <MainHeader v-if="showFullLayout()" />
        <!-- bookmark -->
        <Notices />
        <RouterView />

        <MainFooter v-if="showFullLayout()" />
    </div>
    <ReleasePopup v-if="authUser && currentDepartment" />
    <TodoList
        v-if="authUser && currentDepartment"
        :role="currentDepartment.user_role"
        :type="currentDepartment.type"
        :features="currentDepartment?.plan?.features || []"
    />
    <!-- onboarding -->
    <NewFeatureTour
        v-if="authUser && onboarding && currentDepartment?.type === DepartmentType.Employ && showFullLayout()"
        :steps="onboarding.steps"
        :type="onboarding.type"
        :heading="onboarding.heading"
        :show-modal="showOnboarding"
        @close="(bool) => (showOnboarding = bool)"
    />
</template>

<script>
    import { computed } from 'vue';
    import MainHeader from '@components/MainHeader';
    import MainFooter from '@components/MainFooter';
    import Notices from '@components/Notices/Notices';
    import { useStore } from 'vuex';
    import { DepartmentType } from '@enums/DepartmentType';
    import TodoList from '@components/Employ/OnboardingTodoList/TodoList.vue';
    import { useOnboarding } from '@composables/useOnboarding';
    import NewFeatureTour from '@components/Employ/Onboarding/Modal/NewFeatureTour.vue';
    import ReleasePopup from '@components/ReleaseFeatures/ReleasePopup.vue';

    export default {
        components: {
            ReleasePopup,
            TodoList,
            MainHeader,
            MainFooter,
            Notices,
            NewFeatureTour,
        },
        setup() {
            const store = useStore();
            const currentDepartment = computed(() => store.getters['Departments/GET_CURRENT_DEPARTMENT']);
            const authUser = computed(() => store.getters['UserStore/GET_USER']);
            const backgroundClass = computed(() => store.getters['GlobalStore/GET_BACKGROUND']);

            const displayTodoList = computed(() => store.getters['OnboardingStore/GET_SHOW_TODO']);
            const { showOnboarding, onboarding } = useOnboarding();

            return {
                currentDepartment,
                authUser,
                DepartmentType,
                displayTodoList,
                backgroundClass,
                showOnboarding,
                onboarding,
            };
        },
        methods: {
            showFullLayout() {
                return (
                    (this.$route.meta.requiresAuth &&
                        '404' !== this.$route.name &&
                        'login-complete-profile' !== this.$route.name) ||
                    'verify-certificate' === this.$route.name
                );
            },
        },
    };
</script>
